import { RouteType } from "types/RouteType";
import type { RootStore } from "stores/index";
import RecurringTransactionsStore from "./RecurringTransactions.Store";

/**
 * RecurringTransactions Route
 *
 * Manage recurring transactions per Phase 3
 * - Create/edit recurring transaction templates
 * - View pending instances for approval
 * - Schedule management
 */
const recurringTransactionsRoute: RouteType = {
  name: "Recurring Transactions",
  path: "/accounting/recurring-transactions",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Recurring Transactions",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./RecurringTransactions.Header"),
    },
    body: {
      component: () => import("./RecurringTransactions.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any)
      .recurringTransactionsStore as RecurringTransactionsStore;
    if (store) {
      await Promise.all([
        store.loadRecurringTransactions(),
        store.loadPendingInstances(),
      ]);
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any)
      .recurringTransactionsStore as RecurringTransactionsStore;
    if (store) {
      await store.loadRecurringTransactions();
    }
  },
  dialogs: [
    {
      name: "createRecurringTransaction",
      title: "Create Recurring Transaction",
      component: () => import("./dialogs/CreateRecurringDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any)
          .recurringTransactionsStore as RecurringTransactionsStore;
        await store?.createRecurringTransaction();
      },
      cancelButton: true,
      height: 580,
    },
    {
      name: "editRecurringTransaction",
      title: "Edit Recurring Transaction",
      component: () => import("./dialogs/EditRecurringDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any)
          .recurringTransactionsStore as RecurringTransactionsStore;
        await store?.updateRecurringTransaction();
      },
      cancelButton: true,
      height: 580,
    },
    {
      name: "approveRecurringInstance",
      title: "Approve Recurring Transaction",
      component: () => import("./dialogs/ApproveRecurringDialog.Body"),
      cancelButton: true,
      height: 400,
    },
  ],
};

export default recurringTransactionsRoute;
